var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<article class=\"card card-location card-location-compact\" ng-class=\"{'card-selected': $ctrl.active}\">\n<div class=\"cropped-image\" ng-style=\"{'background-image':'url(' + $ctrl.locationObj.image + ')'}\">\n</div>\n<div class=\"card-content\">\n<div>\n<div ng-if=\"$ctrl.showInfo\" class=\"card-info-icon pull-right\" ng-click=\"$ctrl.onLocationInfoClicked($event)\">\n<span class=\"icon icon-26 icon-i\"></span>\n</div>\n<div class=\"card-heading\" title=\"{{:: $ctrl.locationObj.card_title }}\">\n{{:: $ctrl.locationObj.card_title }}\n</div>\n</div>\n<p class=\"description overflow-ellipsis\">\n{{:: $ctrl.locationObj.address.toString() }}\n</p>\n</div>\n</article>\n";
var id1="app/locations/location-card-compact.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/locations/location-card-compact.tpl.html
// module id = 509
// module chunks = 2